import { __decorate, __metadata, __param } from "tslib";
import { GoodTableColumnFixedType } from '@/components/GoodTable/GoodTable.types';
import { Symbols } from '@/symbols';
import { getDateFormatYM, getDateFormatYMD } from '@/utils/date';
import { inject, injectable } from 'inversify';
import { CompanyDataAnalysisViewType } from './CompanyDataAnalysis.type';
import { toThousands, getLineBarProportion } from '@/utils/number';
import { analyticsEmailSeriesOption, getBarOptions, getLineBarOptions, getLineOption } from './echartsOption';
import { GRANULARITY, CompanyDataAnalysisEventKey, CompanyDataAnalysisDataSet, CompanyDataAnalysisWorkspaceDashBoardKey, CompanyDataAnalysisKeyType } from '@/apis/service/company/CompanyDataAnalysisApi.type';
import _ from 'lodash';
import { E_ROUTE_COMPANY_ORGANIZATION } from '@/router/routes/route.types';
import { BaseDataAnalysisOptions } from '@/service/common/BaseDataAnalysisOptions';
const sortFunctionMap = {
    [CompanyDataAnalysisKeyType.BIO_NEW_USER]: `${CompanyDataAnalysisEventKey.BIO}_login_cnt:desc`,
    [CompanyDataAnalysisKeyType.CHEMICAL_NEW_USER]: `${CompanyDataAnalysisEventKey.CHEMICAL}_login_cnt:desc`,
    [CompanyDataAnalysisKeyType.SYNAPSE_NEW_USER]: `${CompanyDataAnalysisEventKey.SYNAPSE}_login_cnt:desc`,
    [CompanyDataAnalysisKeyType.EUREKA_NEW_USER]: `${CompanyDataAnalysisEventKey.EUREKA}_login_cnt:desc`,
    [CompanyDataAnalysisKeyType.ANALYTICS_NEW_USER]: `${CompanyDataAnalysisEventKey.ANALYTICS}_login_cnt:desc`,
    [CompanyDataAnalysisKeyType.SYNAPSE_SEARCH]: `${CompanyDataAnalysisEventKey.SYNAPSE}_login_cnt:desc`,
    [CompanyDataAnalysisKeyType.EUREKA_AIR_NEW_USER]: `${CompanyDataAnalysisEventKey.EUREKA_AIR}_login_cnt:desc`,
    [CompanyDataAnalysisKeyType.EUREKA_AIR_SUMMARY]: `${CompanyDataAnalysisEventKey.EUREKA_AIR}_login_cnt:desc`,
    [CompanyDataAnalysisKeyType.EUREKA_SUMMARY]: `${CompanyDataAnalysisEventKey.EUREKA}_login_cnt:desc`,
};
export const productSoreList = [
    CompanyDataAnalysisEventKey.ANALYTICS,
    CompanyDataAnalysisEventKey.EUREKA,
    CompanyDataAnalysisEventKey.BIO,
    CompanyDataAnalysisEventKey.CHEMICAL,
    CompanyDataAnalysisEventKey.SYNAPSE,
    CompanyDataAnalysisEventKey.NO_PERMISSION
];
export const analyticsSortList = [
    CompanyDataAnalysisEventKey.SIMPLE_SEARCH,
    CompanyDataAnalysisEventKey.FIELD_SEARCH,
    CompanyDataAnalysisEventKey.COMMAND_SEARCH,
    CompanyDataAnalysisEventKey.PROJECT_SEARCH,
    CompanyDataAnalysisEventKey.BULK_SEARCH,
    CompanyDataAnalysisEventKey.SEMANTIC_SEARCH,
    CompanyDataAnalysisEventKey.IMAGE_SEARCH,
    CompanyDataAnalysisEventKey.EXPAND_SEARCH,
    CompanyDataAnalysisEventKey.CLASSIFICATION_SEARCH,
    CompanyDataAnalysisEventKey.LEGAL_SEARCH,
    CompanyDataAnalysisEventKey.HEADER_SEARCH
];
export const workspaceCreatedAndCooperationSortList = [
    CompanyDataAnalysisEventKey.COMPANY,
    CompanyDataAnalysisEventKey.PERSONAL
];
export const workspaceTagSortList = [
    CompanyDataAnalysisEventKey.SINGLE_TAG,
    CompanyDataAnalysisEventKey.BATCH_TAG,
    CompanyDataAnalysisEventKey.RULE_TAG,
    CompanyDataAnalysisEventKey.AI_TAG
];
export const eurekaRdPvUvSortList = [
    CompanyDataAnalysisEventKey.EUREKA_RD_TECHNICAL_QA,
    CompanyDataAnalysisEventKey.EUREKA_RD_FIND_SOLUTION,
    CompanyDataAnalysisEventKey.EUREKA_RD_QUICK_RESEARCH,
    CompanyDataAnalysisEventKey.EUREKA_RD_EVALUATE_FEASIBILITY,
    CompanyDataAnalysisEventKey.EUREKA_RD_FEASIBILITY_ANALYSIS_ASSISTANT,
    CompanyDataAnalysisEventKey.EUREKA_RD_HOMEPAGE_SEARCH,
    CompanyDataAnalysisEventKey.EUREKA_RD_PATENT_SEARCH,
    CompanyDataAnalysisEventKey.EUREKA_RD_LITERATURE_SEARCH,
    CompanyDataAnalysisEventKey.EUREKA_RD_IDEA_VALIDATION,
    CompanyDataAnalysisEventKey.EUREKA_RD_INVENTION_DISCLOSURE
];
export const eurekaIPSortList = [
    CompanyDataAnalysisEventKey.EUREKA_IP_NOVELTY_SEARCH,
    CompanyDataAnalysisEventKey.EUREKA_IP_PATENT_DRAFTING_CN,
    CompanyDataAnalysisEventKey.EUREKA_IP_PATENT_DRAFTING_US,
    CompanyDataAnalysisEventKey.EUREKA_IP_PATENT_DRAFTING_EU,
    CompanyDataAnalysisEventKey.EUREKA_IP_PATENT_TRANSLATION,
    CompanyDataAnalysisEventKey.EUREKA_IP_DESIGN_FTO_SEARCH,
    CompanyDataAnalysisEventKey.EUREKA_IP_FTO_SEARCH
];
export const eurekaMaterialsSortList = [
    CompanyDataAnalysisEventKey.EUREKA_MATERIALS_MATERIAL_PERFORMANCE_ANALYSIS,
    CompanyDataAnalysisEventKey.EUREKA_MATERIALS_ALLOY_COMPOSITION_ANALYSIS,
    CompanyDataAnalysisEventKey.EUREKA_MATERIALS_MULTI_D_SEARCH,
    CompanyDataAnalysisEventKey.EUREKA_MATERIALS_SUBSTANCE_INQUIRY,
    CompanyDataAnalysisEventKey.EUREKA_MATERIALS_STRUCTURE_SEARCH,
    CompanyDataAnalysisEventKey.EUREKA_MATERIALS_MATERIAL_SYNTHESIS_PROCESS,
    CompanyDataAnalysisEventKey.EUREKA_MATERIALS_MATERIAL_PROFILE_SEARCH,
    CompanyDataAnalysisEventKey.EUREKA_MATERIALS_COMPOSITION_SEARCH,
    CompanyDataAnalysisEventKey.EUREKA_MATERIALS_SMART_SEARCH_PATENT,
    CompanyDataAnalysisEventKey.EUREKA_MATERIALS_SMART_SEARCH_LITERATURE
];
export const defaultChartOrTableHeight = {
    defaultChartHeight: '450px',
    defaultTableHeight: '550px',
    defaultChartHeightWithTopBox: '435px',
    defaultTableHeightWithTopBox: '435px',
};
export var COMPANY_DATA_ANALYSIS_TABS;
(function (COMPANY_DATA_ANALYSIS_TABS) {
    COMPANY_DATA_ANALYSIS_TABS["User"] = "user";
    COMPANY_DATA_ANALYSIS_TABS["Analytics"] = "analytics";
    COMPANY_DATA_ANALYSIS_TABS["Eureka"] = "eureka";
    COMPANY_DATA_ANALYSIS_TABS["EurekaAIR"] = "eurekaAIR";
    COMPANY_DATA_ANALYSIS_TABS["Copilot"] = "copilot";
    COMPANY_DATA_ANALYSIS_TABS["Workspace"] = "workspace";
    COMPANY_DATA_ANALYSIS_TABS["Bio"] = "bio";
    COMPANY_DATA_ANALYSIS_TABS["Chemical"] = "chemical";
    COMPANY_DATA_ANALYSIS_TABS["Synapse"] = "synapse";
    COMPANY_DATA_ANALYSIS_TABS["Connect"] = "connect";
})(COMPANY_DATA_ANALYSIS_TABS || (COMPANY_DATA_ANALYSIS_TABS = {}));
export function makeCompanyDataAnalysisQueries(company_id) {
    return {
        company_id,
        begin_at: getDateFormatYMD((new Date(new Date().setDate(new Date().getDate() - 30))), 'cn'),
        end_at: getDateFormatYMD((new Date(new Date().getTime() - 24 * 60 * 60 * 1000).toISOString().split('T')[0]), 'cn'),
        granularity: GRANULARITY.WEEK,
        identifier: '',
        package_ids: [],
    };
}
export function getCompanyDataAnalysisParams(queries) {
    return {
        company_id: queries.company_id,
        begin_at: Date.parse(queries.begin_at),
        end_at: Date.parse(queries.end_at),
        granularity: queries.granularity,
    };
}
export function getCompanyDataAnalysisSummaryParams(queries) {
    return {
        company_id: queries.company_id,
        begin_at: Date.parse(queries.begin_at),
        end_at: Date.parse(queries.end_at),
        granularity: queries.granularity,
        identifier: queries.identifier,
        package_ids: queries.package_ids,
    };
}
function makeSynapseActiveUserTableRows(data) {
    return _.map(data, item => {
        return {
            user_info: {
                name: item.name,
                email: item.email,
                mobile_number: item.mobile_number,
                user_id: item.user_id,
            },
            user_id: item.user_id,
            job_title: item.job_title,
            permissions: item.permissions,
            login_cnt: toThousands(item.synapse_login_cnt),
            login_all_cnt: toThousands(item.synapse_login_all_cnt),
            active_search_cnt: {
                // 总
                total: toThousands(item.synapse_active_search_cnt || 0),
                // 通用
                common: toThousands(item.synapse_common_active_search_cnt || 0),
                // 药物检索次数
                drug: toThousands(item.synapse_drug_active_search_cnt || 0),
                // 专利检索次数
                patent: toThousands(item.synapse_patent_active_search_cnt || 0),
                // 药物交易检索次数
                deal: toThousands(item.synapse_drug_deal_active_search_cnt || 0),
                // 临床试验检索次数
                clinicalTrial: toThousands(item.synapse_clinical_trial_active_search_cnt || 0),
                // 临床结果检索次数
                clinicalResult: toThousands(item.synapse_clinical_trial_result_active_search_cnt || 0),
                // 转化医学检索次数
                translationalMedicine: toThousands(item.synapse_translational_medicine_active_search_cnt || 0),
                // 文献检索次数
                paper: toThousands(item.synapse_paper_active_search_cnt || 0),
            },
            detail_all_cnt: {
                // 详情查看总次数
                total: toThousands(item.synapse_detail_all_cnt || 0),
                // 药物详情次数 synapse_drug_detail_cnt
                drug: toThousands(item.synapse_drug_detail_cnt || 0),
                // 药物类型详情次数 synapse_drug_type_detail_cnt
                drugType: toThousands(item.synapse_drug_type_detail_cnt || 0),
                // 靶点详情次数 synapse_target_detail_cnt
                target: toThousands(item.synapse_target_detail_cnt || 0),
                // 适应症详情次数 synapse_disease_detail_cnt
                indication: toThousands(item.synapse_disease_detail_cnt || 0),
                // 机构详情次数 synapse_organization_detail_cnt
                organization: toThousands(item.synapse_organization_detail_cnt || 0),
                // 专利详情次数 synapse_patent_detail_cnt
                patent: toThousands(item.synapse_patent_detail_cnt || 0),
                // 临床详情次数 synapse_clinical_trial_detail_cnt
                clinicalTrial: toThousands(item.synapse_clinical_trial_detail_cnt || 0),
                // 临床结果详情次数 synapse_clinical_trial_result_detail_cnt
                clinicalResult: toThousands(item.synapse_clinical_trial_result_detail_cnt || 0),
                // 新闻详情次数 synapse_news_detail_cnt
                news: toThousands(item.synapse_news_detail_cnt || 0),
                // 文献详情次数 synapse_paper_detail_cnt
                literature: toThousands(item.synapse_paper_detail_cnt || 0),
            },
        };
    });
}
function makeEurekaAIRActiveUserTableRows(data) {
    return _.map(data, item => {
        return {
            user_info: {
                name: item.name,
                email: item.email,
                mobile_number: item.mobile_number,
                user_id: item.user_id,
            },
            user_id: item.user_id,
            job_title: item.job_title,
            permissions: item.permissions,
            login_cnt: toThousands(item.eureka_air_login_cnt),
            login_all_cnt: toThousands(item.eureka_air_login_all_cnt),
            eureka_air_tech_seek_cnt: toThousands(item.eureka_air_tech_seek_cnt),
            eureka_air_tech_mind_cnt: toThousands(item.eureka_air_tech_mind_cnt),
            eureka_air_tech_research_cnt: {
                // 总
                total: toThousands(item.eureka_air_tech_research_total_cnt || 0),
                view: toThousands(item.eureka_air_tech_research_view_cnt || 0),
                create: toThousands(item.eureka_air_tech_research_create_cnt || 0),
            },
        };
    });
}
export function makeConcurrencyUserDetailsTableRows(data) {
    return _.map(data, item => {
        return {
            user_info: {
                name: item.name,
                email: item.email,
                mobile_number: item.mobile_number,
                user_id: item.user_id,
            },
            user_id: item.user_id,
            job_title: item.job_title,
            event_date: getDateFormatYMD(item.event_date),
            permissions: item.permissions,
            packages: item.packages,
        };
    });
}
export function makeKickedOutUserDetailTableRows(data) {
    return _.map(data, item => {
        return {
            user_info: {
                name: item.name,
                email: item.email,
                mobile_number: item.mobile_number,
            },
            user_id: item.user_id,
            job_title: item.job_title,
            permissions: item.permissions,
            kicked_out_by_self: toThousands(item.kicked_out_by_self_pv || 0),
            kicked_out_by_others: toThousands(item.kicked_out_by_others_pv || 0),
        };
    });
}
export function makeEurekaActiveUserTableRows(data) {
    return _.map(data, item => {
        return {
            user_info: {
                name: item.name,
                email: item.email,
                mobile_number: item.mobile_number,
                user_id: item.user_id,
            },
            user_id: item.user_id,
            job_title: item.job_title,
            permissions: item.permissions,
            invalid_permissions: item.invalid_permissions,
            join_date: getDateFormatYMD(item.join_date),
            created_date: getDateFormatYMD(item.created_date),
            login_cnt: toThousands(item.eureka_login_cnt || 0),
            login_all_cnt: toThousands(item.eureka_login_all_cnt || 0),
            eureka_login_days: toThousands(item.eureka_login_days || 0),
            technical_qa: toThousands(item.technical_qa_pv || 0),
            find_solution: toThousands(item.find_solution_pv || 0),
            quick_research: toThousands(item.quick_research_pv || 0),
            evaluate_feasibility: toThousands(item.evaluate_feasibility_pv || 0),
            feasibility_analysis_assistant: toThousands(item.feasibility_analysis_assistant_pv || 0),
            homepage_search: toThousands(item.homepage_search_pv || 0),
            rd_patent_search: toThousands(item.rd_patent_search_pv || 0),
            rd_paper_search: toThousands(item.rd_paper_search_pv || 0),
            rd_novelty_check: toThousands(item.rd_novelty_check_pv || 0),
            rd_ai_disclosure: toThousands(item.rd_ai_disclosure_pv || 0),
            novelty_search: toThousands(item.novelty_search_pv || 0),
            specification_cn: toThousands(item.ip_specification_cn_pv || 0),
            specification_us: toThousands(item.ip_specification_us_pv || 0),
            specification_eu: toThousands(item.ip_specification_eu_pv || 0),
            patent_translation: toThousands(item.patent_translation_pv || 0),
            design_fto_search: toThousands(item.design_fto_search_pv || 0),
            fto_search: toThousands(item.fto_search_pv || 0),
            material_performance_analysis: toThousands(item.material_performance_analysis_pv || 0),
            alloy_composition_analysis: toThousands(item.alloy_composition_analysis_pv || 0),
            multi_d_search: toThousands(item.multi_d_search_pv || 0),
            substance_inquiry: toThousands(item.substance_inquiry_pv || 0),
            structure_search: toThousands(item.structure_search_pv || 0),
            material_synthesis_process: toThousands(item.material_synthesis_process_pv || 0),
            material_profile_search: toThousands(item.material_profile_search_pv || 0),
            composition_search: toThousands(item.composition_search_pv || 0),
            ms_patent_search: toThousands(item.ms_patent_search_pv || 0),
            ms_paper_search: toThousands(item.ms_paper_search_pv || 0),
            patent_view: toThousands(item.patent_view_pv || 0),
            paper_view: toThousands(item.paper_view_pv || 0),
        };
    });
}
let CompanyDataAnalysisService = class CompanyDataAnalysisService {
    constructor(i18n, globalViewService, companyDataAnalysisApi) {
        this.i18n = i18n;
        this.globalViewService = globalViewService;
        this.companyDataAnalysisApi = companyDataAnalysisApi;
        this.dashBoard = [];
        this.dashBoardLoading = false;
        // 24.7 由于数据问题 暂时不上
        this.isOnline = false;
        this.granularity = GRANULARITY.DAY;
    }
    getDashBoardData(params) {
        this.dashBoardLoading = true;
        this.companyDataAnalysisApi.getCompanyDataAnalysisDashboard(params).then(data => {
            // 若有更多的dashboard类型，再进行拓展
            if (params.report_name === CompanyDataAnalysisKeyType.WORKSPACE_SUMMARY) {
                this.dashBoard = this.getWorkspaceDashboard(data);
            }
            else if (params.report_name === CompanyDataAnalysisKeyType.EUREKA_NEW_USER) {
                this.dashBoard = this.getEurekaDashboard(data);
            }
        }).finally(() => {
            this.dashBoardLoading = false;
        });
    }
    toCompanyDataAnalysisOptions(company_id) {
        return {
            name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_DATA_ANALYSIS,
            params: {
                id: company_id,
                tab: COMPANY_DATA_ANALYSIS_TABS.Analytics,
            },
        };
    }
    getDateFormat(date) {
        if (this.granularity === GRANULARITY.MONTH) {
            return getDateFormatYM(date);
        }
        return getDateFormatYMD(date);
    }
    // 计算比例
    getRatio(value, total) {
        return total === 0 ? 0 : parseFloat((value / total * 100).toFixed(2));
    }
    getSectionsByProduct(product) {
        const sectionMap = {
            [COMPANY_DATA_ANALYSIS_TABS.Analytics]: [
                {
                    id: CompanyDataAnalysisKeyType.ANALYTICS_NEW_USER,
                    label: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
                },
                {
                    id: CompanyDataAnalysisKeyType.ANALYTICS_SEARCH,
                    label: this.i18n.t('backoffice.company.dataAnalysis.search'),
                },
                {
                    id: CompanyDataAnalysisKeyType.ANALYTICS_EMAIL_ALERT,
                    label: this.i18n.t('backoffice.company.dataAnalysis.alert'),
                },
                {
                    id: CompanyDataAnalysisKeyType.ANALYTICS_CUSTOM_ANALYSIS,
                    label: this.i18n.t('backoffice.company.dataAnalysis.customAnalysis'),
                }
            ],
            [COMPANY_DATA_ANALYSIS_TABS.User]: [
                {
                    id: CompanyDataAnalysisKeyType.COMPANY_NEW_USER,
                    label: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
                },
                {
                    id: CompanyDataAnalysisKeyType.CONCURRENCY,
                    label: this.i18n.t('backoffice.company.dataAnalysis.limitReached'),
                },
                {
                    id: CompanyDataAnalysisKeyType.KICK_OUT_BY_SELF,
                    label: this.i18n.t('backoffice.company.dataAnalysis.logout'),
                }
            ],
            [COMPANY_DATA_ANALYSIS_TABS.Eureka]: [
                {
                    id: CompanyDataAnalysisKeyType.EUREKA_NEW_USER,
                    label: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
                },
                {
                    id: CompanyDataAnalysisKeyType.EUREKA_LOGIN,
                    label: this.i18n.t('backoffice.company.dataAnalysis.loginEureka'),
                },
                {
                    id: CompanyDataAnalysisKeyType.EUREKA_RD_USAGE_REPORT,
                    label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRd'),
                },
                {
                    id: CompanyDataAnalysisKeyType.EUREKA_IP_USAGE_REPORT,
                    label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIp'),
                },
                {
                    id: CompanyDataAnalysisKeyType.EUREKA_MATERIALS_USAGE_REPORT,
                    label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterials'),
                }
            ],
            [COMPANY_DATA_ANALYSIS_TABS.Synapse]: [
                {
                    id: CompanyDataAnalysisKeyType.SYNAPSE_NEW_USER,
                    label: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
                },
                {
                    id: CompanyDataAnalysisKeyType.SYNAPSE_SEARCH,
                    label: this.i18n.t('backoffice.company.dataAnalysis.activeUserTitle'),
                }
            ],
            [COMPANY_DATA_ANALYSIS_TABS.Workspace]: [
                {
                    id: CompanyDataAnalysisKeyType.WORKSPACE_LOGIN,
                    label: this.i18n.t('backoffice.company.dataAnalysis.loggedWorkspace'),
                },
                {
                    id: CompanyDataAnalysisKeyType.WORKSPACE_SHARE,
                    label: this.i18n.t('backoffice.company.dataAnalysis.share'),
                },
                {
                    id: CompanyDataAnalysisKeyType.WORKSPACE_TAG,
                    label: this.i18n.t('backoffice.company.dataAnalysis.tagging'),
                }
            ],
            [COMPANY_DATA_ANALYSIS_TABS.EurekaAIR]: [
                {
                    id: CompanyDataAnalysisKeyType.EUREKA_AIR_NEW_USER,
                    label: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
                },
                {
                    id: CompanyDataAnalysisKeyType.EUREKA_AIR_SUMMARY,
                    label: this.i18n.t('backoffice.company.dataAnalysis.activeUserTitle'),
                },
                {
                    id: CompanyDataAnalysisKeyType.EUREKA_AIR_TECH_SEEK,
                    label: this.i18n.t('backoffice.company.dataAnalysis.EurekaAIR_TechSeek'),
                },
                {
                    id: CompanyDataAnalysisKeyType.EUREKA_AIR_TECH_MIND,
                    label: this.i18n.t('backoffice.company.dataAnalysis.EurekaAIR_TechMind'),
                },
                {
                    id: CompanyDataAnalysisKeyType.EUREKA_AIR_TECH_RESEARCH_CREATE,
                    label: this.i18n.t('backoffice.company.dataAnalysis.EurekaAIR_TechResearch'),
                }
            ],
            [COMPANY_DATA_ANALYSIS_TABS.Connect]: [
                {
                    id: CompanyDataAnalysisKeyType.CONNECT_USAGE,
                    label: this.i18n.t('backoffice.company.dataAnalysis.connect.successfulCallsTitle'),
                },
                {
                    id: CompanyDataAnalysisKeyType.CONNECT_ATTEMPTED,
                    label: this.i18n.t('backoffice.company.dataAnalysis.connect.attemptedCallsTitle'),
                },
                {
                    id: CompanyDataAnalysisKeyType.CONNECT_USAGE_DETAIL,
                    label: this.i18n.t('backoffice.company.dataAnalysis.connect.usageDetailTitle'),
                }
            ],
        };
        return sectionMap[product] || [];
    }
    getEurekaAIRDashboard(data) {
        return [
            {
                title: this.i18n.t('backoffice.company.dataAnalysis.eurekaAIRDashboard.week'),
                key: CompanyDataAnalysisWorkspaceDashBoardKey.LAST_WEEK_EUREKA_AIR_NEW_USER_COUNT,
                count: toThousands(data.last_week_eureka_air_new_user_count || 0),
                tips: this.i18n.t('backoffice.company.dataAnalysis.eurekaAIRDashboard.weekTips'),
            },
            {
                title: this.i18n.t('backoffice.company.dataAnalysis.eurekaAIRDashboard.month'),
                key: CompanyDataAnalysisWorkspaceDashBoardKey.LAST_MONTH_EUREKA_AIR_NEW_USER_COUNT,
                count: toThousands(data.last_month_eureka_air_new_user_count || 0),
                tips: this.i18n.t('backoffice.company.dataAnalysis.eurekaAIRDashboard.monthTips'),
            },
            {
                title: this.i18n.t('backoffice.company.dataAnalysis.eurekaAIRDashboard.total'),
                key: CompanyDataAnalysisWorkspaceDashBoardKey.TOTAL_EUREKA_AIR_COUNT,
                count: toThousands(data.total_eureka_air_count || 0),
                tips: this.i18n.t('backoffice.company.dataAnalysis.eurekaAIRDashboard.totalTips'),
            }
        ];
    }
    getEurekaDashboard(data) {
        return [
            {
                title: this.i18n.t('backoffice.company.dataAnalysis.eurekaAIRDashboard.week'),
                key: CompanyDataAnalysisWorkspaceDashBoardKey.LAST_WEEK_EUREKA_NEW_USER_COUNT,
                count: toThousands(data.last_week_eureka_new_user_count || 0),
                tips: this.i18n.t('backoffice.company.dataAnalysis.eurekaDashboard.weekTips'),
            },
            {
                title: this.i18n.t('backoffice.company.dataAnalysis.eurekaAIRDashboard.month'),
                key: CompanyDataAnalysisWorkspaceDashBoardKey.LAST_MONTH_EUREKA_NEW_USER_COUNT,
                count: toThousands(data.last_month_eureka_new_user_count || 0),
                tips: this.i18n.t('backoffice.company.dataAnalysis.eurekaDashboard.monthTips'),
            },
            {
                title: this.i18n.t('backoffice.company.dataAnalysis.eurekaAIRDashboard.total'),
                key: CompanyDataAnalysisWorkspaceDashBoardKey.TOTAL_EUREKA_COUNT,
                count: toThousands(data.total_eureka_count || 0),
                tips: this.i18n.t('backoffice.company.dataAnalysis.eurekaDashboard.totalTips'),
            }
        ];
    }
    getWorkspaceDashboard(data) {
        return [
            {
                title: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.PATENT_CNT}_title`),
                key: CompanyDataAnalysisWorkspaceDashBoardKey.PATENT_CNT,
                count: toThousands(data.patent_cnt || 0),
            },
            {
                title: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.TOTAL_WORKSPACE_CNT}_title`),
                key: CompanyDataAnalysisWorkspaceDashBoardKey.TOTAL_WORKSPACE_CNT,
                count: toThousands(data.total_workspace_cnt || 0),
            },
            ...(this.isOnline
                ? [{
                        title: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.COMPANY_WORKSPACE_CNT}_title`),
                        key: CompanyDataAnalysisWorkspaceDashBoardKey.COMPANY_WORKSPACE_CNT,
                        count: toThousands(data.company_workspace_cnt),
                        ratio: this.getRatio(data.company_workspace_cnt, data.total_workspace_cnt),
                        tips: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.COMPANY_WORKSPACE_CNT}_tips`),
                    }]
                : []),
            ...(this.isOnline
                ? [{
                        title: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.PERSONAL_WORKSPACE_CNT}_title`),
                        key: CompanyDataAnalysisWorkspaceDashBoardKey.PERSONAL_WORKSPACE_CNT,
                        count: toThousands(data.personal_workspace_cnt),
                        ratio: this.getRatio(data.personal_workspace_cnt, data.total_workspace_cnt),
                        tips: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.PERSONAL_WORKSPACE_CNT}_tips`),
                    }]
                : []),
            ...(this.isOnline
                ? [{
                        title: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.COOPERATIVE_COMPANY_WORKSPACE_CNT}_title`),
                        key: CompanyDataAnalysisWorkspaceDashBoardKey.COOPERATIVE_COMPANY_WORKSPACE_CNT,
                        count: toThousands(data.cooperative_company_workspace_cnt + data.cooperative_personal_workspace_cnt),
                        ratio: this.getRatio(data.cooperative_company_workspace_cnt + data.cooperative_personal_workspace_cnt, data.total_workspace_cnt),
                        tips: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.COOPERATIVE_COMPANY_WORKSPACE_CNT}_tips`),
                    }]
                : []),
            {
                title: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.CUSTOM_FIELD_TOTAL_CNT}_title`),
                key: CompanyDataAnalysisWorkspaceDashBoardKey.CUSTOM_FIELD_TOTAL_CNT,
                count: toThousands(data.custom_field_total_cnt || 0),
            },
            ...(this.isOnline
                ? [{
                        title: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.COMPANY_CUSTOM_FIELD_TOTAL_CNT}_title`),
                        key: CompanyDataAnalysisWorkspaceDashBoardKey.COMPANY_CUSTOM_FIELD_TOTAL_CNT,
                        count: toThousands(data.company_custom_field_total_cnt),
                        ratio: this.getRatio(data.company_custom_field_total_cnt, data.custom_field_total_cnt),
                        tips: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.COMPANY_CUSTOM_FIELD_TOTAL_CNT}_tips`),
                    }]
                : []),
            ...(this.isOnline
                ? [{
                        title: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.PERSONAL_CUSTOM_FIELD_TOTAL_CNT}_title`),
                        key: CompanyDataAnalysisWorkspaceDashBoardKey.PERSONAL_CUSTOM_FIELD_TOTAL_CNT,
                        count: toThousands(data.personal_custom_field_total_cnt),
                        ratio: this.getRatio(data.personal_custom_field_total_cnt, data.custom_field_total_cnt),
                        tips: this.i18n.t(`backoffice.company.dataAnalysis.workspaceDashBoard.${CompanyDataAnalysisWorkspaceDashBoardKey.PERSONAL_CUSTOM_FIELD_TOTAL_CNT}_tips`),
                    }]
                : [])
        ];
    }
    getPvUvStatistics({ total_count = 0, user_count = 0, key }) {
        const average = user_count !== 0 ? parseFloat((total_count / user_count).toFixed(2)) : 0;
        return [
            {
                label: this.i18n.t(`backoffice.company.dataAnalysis.${key}Pv`),
                tip: this.i18n.t(`backoffice.company.dataAnalysis.${key}PvTip`) === `backoffice.company.dataAnalysis.${key}PvTip` ? '' : this.i18n.t(`backoffice.company.dataAnalysis.${key}PvTip`),
                value: toThousands(total_count),
            },
            {
                label: this.i18n.t(`backoffice.company.dataAnalysis.${key}Uv`),
                tip: this.i18n.t(`backoffice.company.dataAnalysis.${key}UvTip`) === `backoffice.company.dataAnalysis.${key}UvTip` ? '' : this.i18n.t(`backoffice.company.dataAnalysis.${key}UvTip`),
                value: toThousands(user_count),
            },
            {
                label: this.i18n.t(`backoffice.company.dataAnalysis.${key}Avg`),
                tip: this.i18n.t(`backoffice.company.dataAnalysis.${key}AvgTip`) === `backoffice.company.dataAnalysis.${key}AvgTip` ? '' : this.i18n.t(`backoffice.company.dataAnalysis.${key}AvgTip`),
                value: toThousands(average),
            }
        ];
    }
    getAlertEmailStatistics({ Recipients = 0, Read = 0, Clicked = 0 }) {
        return [
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.recipients'),
                value: toThousands(Recipients),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.read'),
                value: toThousands(Read),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.clicked'),
                value: toThousands(Clicked),
            }
        ];
    }
    /**
     *  table columns
     */
    getPvUvTableColumns(labels) {
        return _.compact([
            { label: labels.date, field: 'event_date', width: '120px' },
            labels.user_count && { label: labels.user_count, field: CompanyDataAnalysisDataSet.USER_COUNT },
            labels.total_count && { label: labels.total_count, field: CompanyDataAnalysisDataSet.TOTAL_COUNT }
        ]);
    }
    /**
     * user detail table columns
     */
    getUserDetailPvTableColumns(labels) {
        return [
            { label: labels.date, field: 'event_date', width: '120px' },
            { label: labels.user, field: 'user' },
            { label: labels.total_count, field: CompanyDataAnalysisDataSet.TOTAL_COUNT }
        ];
    }
    /**
     * analytics search table columns
     */
    getAnalyticsSearchTableColumns() {
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.date'), field: CompanyDataAnalysisEventKey.DATE, width: '120px', fixed: GoodTableColumnFixedType.LEFT },
            { label: this.i18n.t('backoffice.company.dataAnalysis.simple'), field: CompanyDataAnalysisEventKey.SIMPLE_SEARCH, width: '120px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.field'), field: CompanyDataAnalysisEventKey.FIELD_SEARCH, width: '120px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.command'), field: CompanyDataAnalysisEventKey.COMMAND_SEARCH, width: '200px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.expert'), field: CompanyDataAnalysisEventKey.PROJECT_SEARCH, width: '120px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.bulk'), field: CompanyDataAnalysisEventKey.BULK_SEARCH, width: '120px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.semantic'), field: CompanyDataAnalysisEventKey.SEMANTIC_SEARCH, width: '120px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.image'), field: CompanyDataAnalysisEventKey.IMAGE_SEARCH, width: '120px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.expand'), field: CompanyDataAnalysisEventKey.EXPAND_SEARCH, width: '120px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.classification'), field: CompanyDataAnalysisEventKey.CLASSIFICATION_SEARCH, width: '120px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.legal'), field: CompanyDataAnalysisEventKey.LEGAL_SEARCH, width: '120px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.headerSearch'), field: CompanyDataAnalysisEventKey.HEADER_SEARCH, width: '140px' }
        ];
    }
    getUserPermissionTableColumns() {
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.date'), field: CompanyDataAnalysisEventKey.DATE, width: '120px', fixed: GoodTableColumnFixedType.LEFT },
            { label: this.i18n.t('backoffice.company.dataAnalysis.analysis'), field: CompanyDataAnalysisEventKey.ANALYTICS, width: '180px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eureka'), field: CompanyDataAnalysisEventKey.EUREKA, width: '180px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.bio'), field: CompanyDataAnalysisEventKey.BIO, width: '180px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.chemical'), field: CompanyDataAnalysisEventKey.CHEMICAL, width: '180px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.synapse'), field: CompanyDataAnalysisEventKey.SYNAPSE, width: '180px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.noPermission'), field: CompanyDataAnalysisEventKey.NO_PERMISSION, width: '180px' }
        ];
    }
    // User Login table columns
    getUserTableColumns(product) {
        const synapseColumn = { label: this.i18n.t('backoffice.company.dataAnalysis.upgradeOrApplyTrial'), field: CompanyDataAnalysisEventKey.SYNAPSE_SUBMIT_APPLY_TRAIL_ACCOUNT_CNT, width: '240px', checked: true };
        const createdDateColumn = { label: this.i18n.t('backoffice.company.dataAnalysis.createdDate'), field: CompanyDataAnalysisEventKey.CREATED_DATE, width: '120px', checked: true, sortable: true };
        const loginCountColumn = { label: this.i18n.t(`backoffice.company.dataAnalysis.${product}LoginCount`), field: CompanyDataAnalysisEventKey.LOGIN_CNT, width: '240px', checked: true, sortable: true };
        const loginTotalCountColumn = { label: this.i18n.t(`backoffice.company.dataAnalysis.${product}LoginTotalCount`), field: CompanyDataAnalysisEventKey.LOGIN_ALL_CNT, width: '240px', checked: true, sortable: true };
        const loginDaysColumn = { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginDays'), field: CompanyDataAnalysisEventKey.EUREKA_LOGIN_DAYS, width: '240px', checked: true, sortable: true };
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.joinDate'), field: CompanyDataAnalysisEventKey.JOIN_DATE, width: '120px', fixed: GoodTableColumnFixedType.LEFT, checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.User'), field: CompanyDataAnalysisEventKey.USER_INFO, width: '240px', fixed: GoodTableColumnFixedType.LEFT, checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.jobTtitle'), field: CompanyDataAnalysisEventKey.JOB_TITLE, width: '200px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.permission'), field: CompanyDataAnalysisEventKey.PERMISSIONS, width: '240px', checked: true },
            ...(product === CompanyDataAnalysisEventKey.EUREKA ? [loginDaysColumn] : []),
            ...(product !== CompanyDataAnalysisEventKey.USER ? [loginCountColumn, loginTotalCountColumn] : []),
            ...(product === CompanyDataAnalysisEventKey.SYNAPSE ? [synapseColumn] : []),
            ...(product !== CompanyDataAnalysisEventKey.USER ? [createdDateColumn] : []),
            { label: this.i18n.t('backoffice.account.userId'), field: CompanyDataAnalysisEventKey.USER_ID, width: '300px', checked: true }
        ];
    }
    getSynapseActiveUserTableColumns() {
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.User'), field: CompanyDataAnalysisEventKey.USER_INFO, width: '280px', fixed: GoodTableColumnFixedType.LEFT, checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.jobTtitle'), field: CompanyDataAnalysisEventKey.JOB_TITLE, width: '200px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.permission'), field: CompanyDataAnalysisEventKey.PERMISSIONS, width: '240px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.synapseLoginCount'), field: CompanyDataAnalysisEventKey.LOGIN_CNT, width: '240px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.synapseLoginTotalCount'), field: CompanyDataAnalysisEventKey.LOGIN_ALL_CNT, width: '240px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.synapseSearchCount'), field: CompanyDataAnalysisEventKey.ACTIVE_SEARCH_CNT, width: '240px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.synapseViewDetailCount'), field: CompanyDataAnalysisEventKey.DETAIL_ALL_CNT, width: '240px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.account.userId'), field: CompanyDataAnalysisEventKey.USER_ID, width: '300px', checked: true }
        ];
    }
    getEurekaAirActiveUserTableColumns() {
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.User'), field: CompanyDataAnalysisEventKey.USER_INFO, width: '280px', fixed: GoodTableColumnFixedType.LEFT, checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.jobTtitle'), field: CompanyDataAnalysisEventKey.JOB_TITLE, width: '200px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.permission'), field: CompanyDataAnalysisEventKey.PERMISSIONS, width: '240px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eureka_airLoginCount'), field: CompanyDataAnalysisEventKey.LOGIN_CNT, width: '240px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eureka_airLoginTotalCount'), field: CompanyDataAnalysisEventKey.LOGIN_ALL_CNT, width: '240px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eureka_air_techSeek'), field: CompanyDataAnalysisEventKey.EUREKA_AIR_TECH_SEEK_CNT, width: '240px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eureka_air_techMind'), field: CompanyDataAnalysisEventKey.EUREKA_AIR_TECH_MIND_CNT, width: '240px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eureka_air_techResearch'), field: CompanyDataAnalysisEventKey.EUREKA_AIR_TECH_RESEARCH_TOTAL_CNT, width: '240px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.account.userId'), field: CompanyDataAnalysisEventKey.USER_ID, width: '300px', checked: true }
        ];
    }
    getEurekaActiveUserTableColumns() {
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.User'), field: CompanyDataAnalysisEventKey.USER_INFO, width: '280px', fixed: GoodTableColumnFixedType.LEFT, checked: true },
            { label: this.i18n.t('backoffice.account.userId'), field: CompanyDataAnalysisEventKey.USER_ID, width: '300px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.jobTtitle'), field: CompanyDataAnalysisEventKey.JOB_TITLE, width: '200px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.permission'), field: CompanyDataAnalysisEventKey.PERMISSIONS, width: '240px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.invalidPermission'), field: CompanyDataAnalysisEventKey.INVALID_PERMISSIONS, width: '240px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.joinDate'), field: CompanyDataAnalysisEventKey.JOIN_DATE, width: '120px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.createdDate'), field: CompanyDataAnalysisEventKey.CREATED_DATE, width: '120px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginDays'), field: CompanyDataAnalysisEventKey.EUREKA_LOGIN_DAYS, width: '240px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eureka_airLoginCount'), field: CompanyDataAnalysisEventKey.LOGIN_CNT, width: '240px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eureka_airLoginTotalCount'), field: CompanyDataAnalysisEventKey.LOGIN_ALL_CNT, width: '240px', checked: true, sortable: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdTechnicalQa'), field: CompanyDataAnalysisEventKey.EUREKA_RD_TECHNICAL_QA, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdFindSolution'), field: CompanyDataAnalysisEventKey.EUREKA_RD_FIND_SOLUTION, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdQuickResearch'), field: CompanyDataAnalysisEventKey.EUREKA_RD_QUICK_RESEARCH, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdEvaluateFeasibility'), field: CompanyDataAnalysisEventKey.EUREKA_RD_EVALUATE_FEASIBILITY, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdFeasibilityAnalysisAssistant'), field: CompanyDataAnalysisEventKey.EUREKA_RD_FEASIBILITY_ANALYSIS_ASSISTANT, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdHomepageSearch'), field: CompanyDataAnalysisEventKey.EUREKA_RD_HOMEPAGE_SEARCH, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdPatentSearch'), field: CompanyDataAnalysisEventKey.EUREKA_RD_PATENT_SEARCH, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdLiteratureSearch'), field: CompanyDataAnalysisEventKey.EUREKA_RD_LITERATURE_SEARCH, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdIdeaValidation'), field: CompanyDataAnalysisEventKey.EUREKA_RD_IDEA_VALIDATION, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdInventionDisclosure'), field: CompanyDataAnalysisEventKey.EUREKA_RD_INVENTION_DISCLOSURE, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPNoveltySearch'), field: CompanyDataAnalysisEventKey.EUREKA_IP_NOVELTY_SEARCH, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPPatentDraftingCN'), field: CompanyDataAnalysisEventKey.EUREKA_IP_PATENT_DRAFTING_CN, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPPatentDraftingUS'), field: CompanyDataAnalysisEventKey.EUREKA_IP_PATENT_DRAFTING_US, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPPatentDraftingEU'), field: CompanyDataAnalysisEventKey.EUREKA_IP_PATENT_DRAFTING_EU, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPPatentTranslation'), field: CompanyDataAnalysisEventKey.EUREKA_IP_PATENT_TRANSLATION, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPDesignFTOSearch'), field: CompanyDataAnalysisEventKey.EUREKA_IP_DESIGN_FTO_SEARCH, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPFTOSearch'), field: CompanyDataAnalysisEventKey.EUREKA_IP_FTO_SEARCH, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialPerformanceAnalysis'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_MATERIAL_PERFORMANCE_ANALYSIS, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialAlloyCompositionAnalysis'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_ALLOY_COMPOSITION_ANALYSIS, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialMultiDSearch'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_MULTI_D_SEARCH, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialSubstanceInquiry'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_SUBSTANCE_INQUIRY, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialStructureSearch'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_STRUCTURE_SEARCH, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialSynthesisProcess'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_MATERIAL_SYNTHESIS_PROCESS, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialProfileSearch'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_MATERIAL_PROFILE_SEARCH, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialCompositionSearch'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_COMPOSITION_SEARCH, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialSmartSearchPatent'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_SMART_SEARCH_PATENT, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialSmartSearchLiterature'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_SMART_SEARCH_LITERATURE, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaPatentView'), field: CompanyDataAnalysisEventKey.EUREKA_PATENT_VIEW, width: '140px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaPaperView'), field: CompanyDataAnalysisEventKey.EUREKA_PAPER_VIEW, width: '140px', checked: true }
        ];
    }
    getNewWorkspaceTableColumns() {
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.date'), field: CompanyDataAnalysisEventKey.DATE, fixed: GoodTableColumnFixedType.LEFT },
            { label: this.i18n.t('backoffice.company.dataAnalysis.companySpace'), field: CompanyDataAnalysisEventKey.COMPANY },
            { label: this.i18n.t('backoffice.company.dataAnalysis.personalSpace'), field: CompanyDataAnalysisEventKey.PERSONAL }
        ];
    }
    getWorkspaceTagTableColumns() {
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.date'), field: CompanyDataAnalysisEventKey.DATE, width: '120px', fixed: GoodTableColumnFixedType.LEFT },
            { label: this.i18n.t('backoffice.company.dataAnalysis.normalTagging'), field: CompanyDataAnalysisEventKey.SINGLE_TAG },
            { label: this.i18n.t('backoffice.company.dataAnalysis.batchTag'), field: CompanyDataAnalysisEventKey.BATCH_TAG },
            { label: this.i18n.t('backoffice.company.dataAnalysis.ruleTag'), field: CompanyDataAnalysisEventKey.RULE_TAG },
            { label: this.i18n.t('backoffice.company.dataAnalysis.aiTag'), field: CompanyDataAnalysisEventKey.AI_TAG }
        ];
    }
    getEurekaRdTableColumns() {
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.date'), field: CompanyDataAnalysisEventKey.DATE, width: '120px', fixed: GoodTableColumnFixedType.LEFT },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdTechnicalQa'), field: CompanyDataAnalysisEventKey.EUREKA_RD_TECHNICAL_QA, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdFindSolution'), field: CompanyDataAnalysisEventKey.EUREKA_RD_FIND_SOLUTION, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdQuickResearch'), field: CompanyDataAnalysisEventKey.EUREKA_RD_QUICK_RESEARCH, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdEvaluateFeasibility'), field: CompanyDataAnalysisEventKey.EUREKA_RD_EVALUATE_FEASIBILITY, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdFeasibilityAnalysisAssistant'), field: CompanyDataAnalysisEventKey.EUREKA_RD_FEASIBILITY_ANALYSIS_ASSISTANT, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdHomepageSearch'), field: CompanyDataAnalysisEventKey.EUREKA_RD_HOMEPAGE_SEARCH, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdPatentSearch'), field: CompanyDataAnalysisEventKey.EUREKA_RD_PATENT_SEARCH, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdLiteratureSearch'), field: CompanyDataAnalysisEventKey.EUREKA_RD_LITERATURE_SEARCH, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdIdeaValidation'), field: CompanyDataAnalysisEventKey.EUREKA_RD_IDEA_VALIDATION, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaRdInventionDisclosure'), field: CompanyDataAnalysisEventKey.EUREKA_RD_INVENTION_DISCLOSURE, width: '140px' }
        ];
    }
    getEurekaIPTableColumns() {
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.date'), field: CompanyDataAnalysisEventKey.DATE, width: '120px', fixed: GoodTableColumnFixedType.LEFT },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPNoveltySearch'), field: CompanyDataAnalysisEventKey.EUREKA_IP_NOVELTY_SEARCH },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPPatentDraftingCN'), field: CompanyDataAnalysisEventKey.EUREKA_IP_PATENT_DRAFTING_CN },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPPatentDraftingUS'), field: CompanyDataAnalysisEventKey.EUREKA_IP_PATENT_DRAFTING_US },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPPatentDraftingEU'), field: CompanyDataAnalysisEventKey.EUREKA_IP_PATENT_DRAFTING_EU },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPPatentTranslation'), field: CompanyDataAnalysisEventKey.EUREKA_IP_PATENT_TRANSLATION },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPDesignFTOSearch'), field: CompanyDataAnalysisEventKey.EUREKA_IP_DESIGN_FTO_SEARCH },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaIPFTOSearch'), field: CompanyDataAnalysisEventKey.EUREKA_IP_FTO_SEARCH }
        ];
    }
    getEurekaMaterialsTableColumns() {
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.date'), field: CompanyDataAnalysisEventKey.DATE, width: '120px', fixed: GoodTableColumnFixedType.LEFT },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialPerformanceAnalysis'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_MATERIAL_PERFORMANCE_ANALYSIS, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialAlloyCompositionAnalysis'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_ALLOY_COMPOSITION_ANALYSIS, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialMultiDSearch'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_MULTI_D_SEARCH, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialSubstanceInquiry'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_SUBSTANCE_INQUIRY, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialStructureSearch'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_STRUCTURE_SEARCH, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialSynthesisProcess'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_MATERIAL_SYNTHESIS_PROCESS, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialProfileSearch'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_MATERIAL_PROFILE_SEARCH, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialCompositionSearch'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_COMPOSITION_SEARCH, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialSmartSearchPatent'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_SMART_SEARCH_PATENT, width: '140px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.eurekaMaterialSmartSearchLiterature'), field: CompanyDataAnalysisEventKey.EUREKA_MATERIALS_SMART_SEARCH_LITERATURE, width: '140px' }
        ];
    }
    getAnalyticsEmailTableColumns() {
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.date'), field: 'event_date', width: '140px', fixed: GoodTableColumnFixedType.LEFT },
            { label: this.i18n.t('backoffice.company.dataAnalysis.recipients'), field: 'recipients', width: '160px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.read'), field: 'read', width: '160px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.clicked'), field: 'clicked', width: '160px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.readRatio'), field: 'read_ratio', width: '180px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.clickedRatio'), field: 'clicked_ratio', width: '180px' }
        ];
    }
    /**
     * 获取用户明细
     * @param data
     * @returns
     */
    getUserDetailTableColumns() {
        return [
            { label: this.i18n.t('backoffice.company.dataAnalysis.User'), field: CompanyDataAnalysisEventKey.USER_INFO, width: '280px', fixed: GoodTableColumnFixedType.LEFT, checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.recipients'), field: 'recipients', width: '160px' },
            { label: this.i18n.t('backoffice.company.dataAnalysis.read'), field: 'read', width: '160px' }
        ];
    }
    // 处理 Email Alert 表格数据
    getAnalysisEmailTableRow(data) {
        return _.map(data, item => {
            return {
                event_date: this.getDateFormat(item.email_send.event_date),
                read: toThousands(item.email_open.user_count),
                clicked: toThousands(item.email_click.user_count),
                recipients: toThousands(item.email_send.user_count),
                read_ratio: (item.email_open.user_count ? (getLineBarProportion(item.email_open.user_count, item.email_send.user_count).replace(/\.00$/, '')) : 0) + '%',
                clicked_ratio: (item.email_open.user_count ? (getLineBarProportion(item.email_click.user_count, item.email_open.user_count).replace(/\.00$/, '')) : 0) + '%',
            };
        });
    }
    getPvUvTableRows(data, key) {
        return _.map(data, item => {
            return {
                event_date: this.getDateFormat(item[`${key}`].event_date),
                total_count: toThousands(item[`${key}`].total_count),
                user_count: toThousands(item[`${key}`].user_count),
            };
        });
    }
    getPvDetailTableRows(data) {
        return _.map(data, item => {
            return {
                event_date: getDateFormatYMD(item.event_date),
                total_count: toThousands(item.total_count),
                user: item,
            };
        });
    }
    getUserTableRows(data, product) {
        const loginCnt = `${product}_login_cnt`;
        const loginAllCnt = `${product}_login_all_cnt`;
        return _.map(data, item => {
            return {
                join_date: getDateFormatYMD(item.join_date),
                user_info: {
                    name: item.name,
                    email: item.email,
                    mobile_number: item.mobile_number,
                    user_id: item.user_id,
                },
                job_title: item.job_title,
                user_id: item.user_id,
                permissions: item.permissions,
                eureka_login_days: toThousands(item.eureka_login_days),
                login_cnt: toThousands(item[loginCnt]),
                login_all_cnt: toThousands(item[loginAllCnt]),
                created_date: getDateFormatYMD(item.created_date),
                synapse_submit_apply_trail_account_cnt: item.synapse_submit_apply_trail_account_cnt,
            };
        });
    }
    getSynapseActiveUserTableRows(data) {
        return makeSynapseActiveUserTableRows(data);
    }
    getEurekaAIRTableRows(data) {
        return makeEurekaAIRActiveUserTableRows(data);
    }
    getBarOptionSeries(index) {
        return {
            type: 'bar',
            label: {
                show: true,
                position: 'top',
                formatter: params => this.getLineBarValueFormatter(params.value[index], 'bar'),
            },
        };
    }
    /**
     * 通用pv uv bar chart option
     */
    getPvUvBarChartOption(params) {
        const { data, total_count, user_count, key } = params;
        const options = getBarOptions();
        const sortedData = _.sortBy(data, 'event_date').reverse();
        const formattedSource = sortedData.map(item => [
            this.getDateFormat(item[key].event_date),
            item[key].total_count,
            item[key].user_count
        ]);
        const baseSource = [['product', total_count, user_count], ...formattedSource];
        options.dataset = { source: baseSource };
        options.series = [this.getBarOptionSeries(1), this.getBarOptionSeries(2)];
        if (user_count && !total_count) {
            options.dataset = { source: [['product', user_count], ...formattedSource.map(item => [item[0], item[2]])] };
            options.series = [this.getBarOptionSeries(1)];
        }
        if (data && data.length > 30) {
            return this.getZoomChartOption(options);
        }
        else {
            return this.cancelZoomChartOption(options);
        }
    }
    getLineOptionDatesAndSeries(params) {
        const { data, sortList, dataSet, columns } = params;
        // 图表从旧到新排序
        const details = _.sortBy(data.data_detail, data => data[sortList[0]].event_date);
        // 生成 key:value as []
        const keysMap = _.zipObject(sortList, _.times(sortList.length, () => []));
        // 生成 日期
        const dates = [];
        _.forEach(details, item => {
            _.forEach(sortList, key => {
                keysMap[key].push(item[key] ? item[key][dataSet] : 0);
            });
            dates.push(this.getDateFormat(item[sortList[0]].event_date));
        });
        const series = Object.entries(keysMap).reduce((arr, [key, value]) => {
            arr.push({
                name: _.find(columns, { field: key }).label,
                type: 'line',
                emphasis: { focus: 'series' },
                data: value,
                label: {
                    show: true,
                    position: 'top',
                    formatter: params => this.getLineBarValueFormatter(params.value, 'bar'),
                },
            });
            return arr;
        }, []);
        return {
            dates,
            series,
        };
    }
    getLineChartOption(params) {
        const { dates, series } = this.getLineOptionDatesAndSeries(params);
        const options = getLineOption();
        _.assign(options.xAxis, { data: dates });
        return {
            ...options,
            series,
        };
    }
    /**
     * 处理堆叠图返回数据
     */
    getStackBarSeries(params) {
        const { data, dataSet, sortList, columns } = params;
        // 图表从旧到新排序
        const details = _.sortBy(data.data_detail, data => data[sortList[0]].event_date);
        if (details.length === 0)
            return;
        // 生成 key:value as []
        const keysMap = _.zipObject(sortList, _.times(sortList.length, () => []));
        // 生成 日期
        const dates = [];
        // 遍历list 将list[index]中的key的pv uv 塞入 keysMap
        _.forEach(details, item => {
            _.forEach(sortList, key => {
                keysMap[key].push(item[key] ? item[key][dataSet] : 0);
            });
            dates.push(this.getDateFormat(item[sortList[0]].event_date));
        });
        // 计算total
        const total = [];
        for (const key in keysMap) {
            if (Object.prototype.hasOwnProperty.call(keysMap, key)) {
                keysMap[key].forEach((value, index) => {
                    const count = value || 0;
                    total[index] = (total[index] || 0) + count;
                });
            }
        }
        // 用 keysMapPv keysMapUv 生成 series
        const series = Object.entries(keysMap).reduce((arr, [key, value]) => {
            arr.push({
                name: _.find(columns, { field: key }).label,
                type: 'bar',
                stack: 'total',
                emphasis: { focus: 'series' },
                data: value,
                label: {
                    show: key === _.last(columns).field,
                    position: 'top',
                    formatter: params => this.getLineBarValueFormatter(total[params.dataIndex], 'bar'),
                },
            });
            return arr;
        }, []);
        return {
            series,
            dates,
        };
    }
    getStackBarCharOption(params) {
        const { data, dataSet, sortList, colorList, columns } = params;
        const options = getBarOptions();
        /* 设置搜索分析颜色 */
        options.color = colorList;
        const seriesParams = {
            data: data,
            dataSet: dataSet,
            sortList: sortList,
            columns: columns,
        };
        const { series, dates } = this.getStackBarSeries(seriesParams);
        options.series = series;
        _.assign(options.xAxis, { data: dates });
        if (dates && dates.length > 30) {
            return this.getZoomChartOption(options);
        }
        else {
            return this.cancelZoomChartOption(options);
        }
    }
    // 处理 email alert 返回数据
    getAnalysisEmailData(data) {
        return _.map(_.sortBy(data, data => data.email_send.event_date), item => {
            return {
                event_date: item.email_send.event_date,
                read: item.email_open.user_count,
                clicked: item.email_click.user_count,
                recipients: item.email_send.user_count,
                read_ratio: item.email_send.user_count ? getLineBarProportion(item.email_open.user_count, item.email_send.user_count) : 0,
                clicked_ratio: item.email_open.user_count ? getLineBarProportion(item.email_click.user_count, item.email_open.user_count) : 0,
            };
        });
    }
    getLineBarValueFormatter(value, type) {
        return type === 'line' ? value + '%' : value < 1000 ? value : (value / 1000).toFixed(2) + 'k';
    }
    getLineBarChartSeries(data) {
        const { data_detail } = data;
        if (data_detail.length === 0)
            return;
        // 图表从旧到新排序
        const details = this.getAnalysisEmailData(data_detail);
        const emailMap = analyticsEmailSeriesOption;
        const columns = this.getAnalyticsEmailTableColumns();
        const series = _.map(emailMap, item => {
            return {
                name: _.find(columns, { field: item.key }).label,
                type: item.type,
                yAxisIndex: item.type === 'line' ? 1 : 0,
                smooth: true,
                label: {
                    show: true,
                    position: 'top',
                    formatter: params => {
                        const val = params.value;
                        return this.getLineBarValueFormatter(Number(val), item.type);
                    },
                },
                tooltip: {
                    valueFormatter: value => {
                        const count = Number(value);
                        return this.getLineBarValueFormatter(count, item.type);
                    },
                },
                data: _.map(details, detail => detail[item.key]),
            };
        });
        return {
            series: series,
            dates: _.map(details, item => this.getDateFormat(item.event_date)),
        };
    }
    getLineBarChartOption(data) {
        const options = getLineBarOptions();
        const { series, dates } = this.getLineBarChartSeries(data);
        options.series = series;
        _.assign(options.xAxis, { data: dates });
        if (dates && dates.length > 30) {
            return this.getZoomChartOption(options);
        }
        else {
            return this.cancelZoomChartOption(options);
        }
    }
    getZoomChartOption(option) {
        option.dataZoom = [
            {
                type: 'slider',
                start: 0,
                end: 50,
                height: '15',
                bottom: '10%',
            },
            {
                type: 'inside',
                start: 0,
                end: 50,
            }
        ];
        option.grid = {
            top: '8%',
            left: '3%',
            right: '4%',
            bottom: '18%',
            containLabel: true,
        };
        return option;
    }
    cancelZoomChartOption(option) {
        option.dataZoom = [];
        option.grid = {
            left: '3%',
            right: '4%',
            bottom: '8%',
            top: '8%',
            containLabel: true,
        };
        return option;
    }
    getAnalysisTableRows(data, dataSet) {
        return data.map(item => {
            const row = {};
            _.forEach(Object.keys(item), key => {
                row[key] = item[key][dataSet];
                _.assign(row, { date: this.getDateFormat(item[key].event_date) });
            });
            return row;
        });
    }
    getSortFunctions(reportName) {
        const sortFunction = sortFunctionMap[reportName];
        return sortFunction ? [sortFunction] : [];
    }
    getDetailTableDefaultParams(params, reportName) {
        const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
        return {
            sEcho: sEcho || 1,
            iDisplayLength: iDisplayLength || 50,
            iDisplayStart: iDisplayStart || 0,
            report_name: reportName,
            order_bys: this.getSortFunctions(reportName),
            ...otherParams,
        };
    }
    updateTotalLabels(chart, selectedList) {
        // 获取当前图表的选项
        const option = chart.getOption();
        if (!option.series[0].data)
            return;
        // 计算每个类别的总和
        const dataIndexes = option.series[0].data.map((_, index) => index);
        const totals = dataIndexes.map(index => {
            let total = 0;
            option.series.forEach(series => {
                // 如果系列在图例中被隐藏，不计入总和
                if ((selectedList[series.name])) {
                    const count = series.data[index] || 0;
                    total += count;
                }
            });
            return total;
        });
        // 计算最后一个展示的key
        const lastTrueKey = [...Object.keys(selectedList)].reverse().find(key => selectedList[key]);
        // 设置顶部系列的标签为总和
        option.series.forEach(series => {
            series.label = {
                show: series.name === lastTrueKey,
                position: 'top',
                formatter: params => this.getLineBarValueFormatter(totals[params.dataIndex], 'bar'),
            };
        });
        // 应用更改
        chart.setOption(option);
    }
    getStackBarSeriesSameValue(option, name) {
        const tpOption = _.cloneDeep(option);
        _.forEach(tpOption.series, series => {
            if (series.name === name) {
                series.label = {
                    show: true,
                    formatter: params => this.getLineBarValueFormatter(params.value, 'bar'),
                    emphasis: {
                        show: true,
                    },
                };
            }
        });
        return tpOption;
    }
    // 字段设置
    getFiledSettingColumns(key, baseColumns) {
        return this.globalViewService.getGlobalViewFields(key).then((res) => {
            if (res.config_value) {
                const settingColumns = JSON.parse(res.config_value);
                // 如果设置的列数和默认列数一样，就按照设置的顺序排序
                if (settingColumns.length === baseColumns.length) {
                    baseColumns = _.sortBy(baseColumns, column => _.indexOf(settingColumns.map(col => col.field), column.field));
                }
                // 同步checked状态
                _.forEach(baseColumns, i => {
                    const column = _.find(settingColumns, col => col.field === i.field);
                    i.checked = column ? column.checked || false : true;
                });
                return baseColumns;
            }
            return baseColumns;
        });
    }
};
CompanyDataAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __param(1, inject(Symbols.GlobalViewService)),
    __param(2, inject(Symbols.CompanyDataAnalysisApi)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CompanyDataAnalysisService);
export { CompanyDataAnalysisService };
export class CompanyDataAnalysisOptions extends BaseDataAnalysisOptions {
    constructor() {
        super(...arguments);
        /**
         * 表格字段
         */
        this.tableFields = [];
        this.chartDescriptionList = [];
        // 统计
        this.statistics = [];
        /**
         * 视图类型
         */
        this.viewType = CompanyDataAnalysisViewType.Chart;
    }
}
